import { schemaOrgOrganizations } from "@/helpers/schemaOrg/organization";
import { schemaOrgPersons } from "@/helpers/schemaOrg/person";
import React from "react";
import { JsonLd } from "react-schemaorg";
import { BreadcrumbList, FAQPage, QAPage } from "schema-dts";

interface BreadcrumbItem {
  name: string;
  item: string; // The URL
}

interface RVOSchemaQAPageProps {
  lastReviewed?: QAPage["lastReviewed"];
  reviewedBy?: QAPage["reviewedBy"];
  abstract?: QAPage["abstract"];
  accountablePerson?: QAPage["accountablePerson"];
  author?: QAPage["author"];
  copyrightYear?: QAPage["copyrightYear"];
  dateCreated?: QAPage["dateCreated"];
  datePublished?: QAPage["datePublished"];
  dateModified?: QAPage["dateModified"];
  genre?: QAPage["genre"];
  headline?: QAPage["headline"];
  inLanguage?: QAPage["inLanguage"];
  description?: QAPage["description"];
  name?: QAPage["name"];
  image?: QAPage["image"];
  keywords?: QAPage["keywords"];
  questions: QAPage["mainEntity"];
  // New Prop for SEO Optimization
  breadcrumbItems?: BreadcrumbItem[];
}

export const RVOSchemaFAQPage = ({
  lastReviewed,
  reviewedBy = schemaOrgOrganizations.SolvingLegal,
  abstract,
  accountablePerson = schemaOrgPersons.ScherbarthHubertus,
  author = schemaOrgPersons.ScherbarthHubertus,
  copyrightYear,
  dateCreated,
  datePublished,
  dateModified,
  genre = "Legal",
  headline,
  inLanguage = "de",
  description,
  name,
  image,
  keywords,
  questions,
  breadcrumbItems,
}: RVOSchemaQAPageProps): React.JSX.Element => {
  return (
    <>
      {/* 1. The FAQ Schema */}
      <JsonLd<FAQPage>
        item={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          description: description,
          name: name,
          image: image,
          keywords: keywords,
          mainEntity: questions,
          lastReviewed: lastReviewed,
          reviewedBy: reviewedBy,
          abstract: abstract,
          accessMode: "textual",
          accountablePerson: accountablePerson,
          author: author,
          copyrightHolder: schemaOrgOrganizations.SolvingLegal,
          copyrightYear: copyrightYear,
          dateCreated: dateCreated,
          datePublished: datePublished,
          dateModified: dateModified,
          genre: genre,
          headline: headline,
          inLanguage: inLanguage,
          publisher: schemaOrgOrganizations.SolvingLegal,
        }}
      />

      {/* 2. The New Breadcrumb Schema (Conditional) */}
      {breadcrumbItems && (
        <JsonLd<BreadcrumbList>
          item={{
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: breadcrumbItems.map((item, index) => ({
              "@type": "ListItem",
              position: index + 1,
              name: item.name,
              item: item.item,
            })),
          }}
        />
      )}
    </>
  );
};
